import { render } from "./ContentMain.vue?vue&type=template&id=10e859c8&scoped=true&ts=true"
import script from "./ContentMain.vue?vue&type=script&lang=ts"
export * from "./ContentMain.vue?vue&type=script&lang=ts"

import "./ContentMain.vue?vue&type=style&index=0&id=10e859c8&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e859c8"]])

export default __exports__